module.exports = __webpack_public_path__ + "media/src/images/icons/person-outline-629e9b0fb8bb2eb5b74aa8176fb24e89.svg";